// @flow

import {articleLoading, articleLoaded} from 'docs/data/article/ArticleReducer';
import type {Article, Dispatcher, GetArticleContentFunction} from 'docs/data';
import type {ArticleEvent} from 'docs/data/article/ArticleReducer';
import type {ArticleCacheKeys} from '../ArticleCacheKeys';

const EMPTY_ARTICLE = {};

export const loadArticle = (
  getArticleContent: GetArticleContentFunction,
  dispatch: Dispatcher<ArticleEvent>,
) => async (path: string, cacheKeys: ArticleCacheKeys) => {
  dispatch(articleLoading());
  try {
    const response = await getArticleContent(path, cacheKeys);
    const {article} = response;
    if (article.version !== cacheKeys.version) {
      // Reload docs to clear the cache when we get a different build version SHA
      window.location.reload();
    }
    dispatch(articleLoaded(article));
    return (article: Article);
  } catch (e) {
    // TODO(ianm): add status code specific handling here.
    window.location = path;
    // This is here to make flow happy, it won't matter since we will have
    // navigated in the line above this.
    return (EMPTY_ARTICLE: Article);
  }
};
